import { Nav } from './sections/Nav';
import { Hero } from './sections/Hero';
import { Since2001 } from './sections/Since2001';
import { About } from './sections/About';
import { Services } from './sections/Services';
import { Stack } from './sections/Stack';
import { Products } from './sections/Products';
import { Contact } from './sections/Contact';
import { Footer } from './sections/Footer';

export default function App() {
  return (
    <>
      <Nav />
      <main id="top">
        <Hero />
        <Since2001 />
        <About />
        <Services />
        <Stack />
        <Products />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
